import { CheckCircle2, Clock, XCircle, PowerOff } from 'lucide-react';
import { Badge } from '@ncoder/ui';

interface StatusConfig {
  label: string;
  icon: typeof CheckCircle2;
  className: string;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  active: { label: 'Active', icon: CheckCircle2, className: 'border-success/30 bg-success/10 text-success' },
  accepted: { label: 'Accepted', icon: CheckCircle2, className: 'border-success/30 bg-success/10 text-success' },
  pending: { label: 'Pending', icon: Clock, className: 'border-warning/30 bg-warning/10 text-warning' },
  invited: { label: 'Invited', icon: Clock, className: 'border-warning/30 bg-warning/10 text-warning' },
  deactivated: { label: 'Deactivated', icon: PowerOff, className: 'border-border bg-muted text-muted-foreground' },
  cancelled: { label: 'Cancelled', icon: XCircle, className: 'border-border bg-muted text-muted-foreground' },
  expired: { label: 'Expired', icon: XCircle, className: 'border-destructive/30 bg-destructive/10 text-destructive' },
};

const DEFAULT_CONFIG: StatusConfig = {
  label: '',
  icon: Clock,
  className: 'border-border bg-muted text-muted-foreground',
};

export function StatusBadge({ status }: { status: string }) {
  const key = status.toLowerCase();
  const cfg = STATUS_CONFIG[key] ?? { ...DEFAULT_CONFIG, label: status };

  return (
    <Badge variant="outline" className={`gap-1 capitalize ${cfg.className}`}>
      <cfg.icon className="h-3 w-3" />
      {cfg.label}
    </Badge>
  );
}
